import React from 'react';

import {useDispatch} from 'react-redux';

import {showUpgradeModal, UPGRADE_MODALS} from 'app/toasts/slice';
import {gt} from 'app/utils/i18n';

interface Props {
  is_paying: boolean;
  contentType: string;
}

export function WarnPublicPaidRequiredMessage({is_paying, contentType}: Props) {
  const dispatch = useDispatch();

  function upgradePlan(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    dispatch(showUpgradeModal(UPGRADE_MODALS.SET_PRIVATE_FLAG));
  }

  return !is_paying ? (
    <p className="alert alert-warning mt-2">
      {gt(
        'Making a %(contentType)s public is available only to paid accounts. Please %(upgradePlan)s to enable this feature',
        {
          contentType,
          upgradePlan: (
            <button
              onClick={upgradePlan}
              className="btn btn-link p-0 align-top font-weight-bold"
            >
              {gt('upgrade your plan')}
            </button>
          ),
        }
      )}
    </p>
  ) : null;
}
